import React from 'react';
import { Tag, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Form, ProjectsConstructorForm } from '@/components';
import { AddColumnDto, ProjectDto, ColumnTypesEnum } from '@/core';
import { FormValueType, useTagColor, useSchemaColumn } from './hooks';
import { getColumnSettings } from '@/pages/Projects.Constructor';
import classes from './ColumnForm.module.scss';

type PropsType = {
  initialValue: FormValueType;
  formUid: string;
  handleCancel?: () => void;
  handleSubmit: (columnData: AddColumnDto) => void;
  isCancelButton?: boolean;
  isTooltip?: boolean;
  columnType: ColumnTypesEnum;
  projectData: ProjectDto;
};

export const ColumnForm = ({
  initialValue,
  formUid,
  handleCancel,
  handleSubmit,
  isCancelButton,
  isTooltip = false,
  columnType,
  projectData,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const tagColor = useTagColor(columnType);
  const schemaColumn = useSchemaColumn(projectData, initialValue);

  return (
    <ProjectsConstructorForm<FormValueType>
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      schema={schemaColumn}
      initialValues={initialValue}
      formUid={formUid}
      isCancelButton={isCancelButton}
    >
      <div className={classes.tagWrapper}>
        <Tag color={tagColor}>{getColumnSettings(columnType).label}</Tag>
      </div>
      <div className={classes.columnNameInput}>
        <Form.Input
          label={false}
          name="sourceName"
          allowClear
          required
          placeholder={t('addColumns.placeholder.sourceName')}
          suffix={
            isTooltip && (
              <Tooltip title={t('addColumns.column.tooltip')}>
                <InfoCircleOutlined className={classes.nameInputTooltipIcon} />
              </Tooltip>
            )
          }
        />
      </div>
      <div className={classes.columnNewNameInput}>
        <Form.Input
          label={false}
          name="name"
          allowClear
          required
          placeholder={t('addColumns.placeholder.name')}
        />
      </div>
    </ProjectsConstructorForm>
  );
};
